<template>
  <Content title="智慧商旅 简单出行" class="bg-white">
    <div class="d-flex justify-content-center">
      <div style="flex-basie: 30%">
        <div
          v-for="(product, i) in productsLeft"
          :key="i"
          class="d-flex justify-content-end align-items-center th-mt-50 product-item"
        >
          <div class="th-mr-36 text-right">
            <div class="product-subtitle th-fs-24">{{ product.title }}</div>
            <div class="product-desc th-fs-16 ts-mt-14">{{ product.desc }}</div>
          </div>
          <div class="product-img-container">
            <img :src="product.negativeImage" />
            <img :src="product.activeImage" />
          </div>
        </div>
      </div>
      <img class="lazyload app-preview-img th-mx-76" data-src="/images/pages/tmc/app-preview.png" />
      <div style="flex-basie: 30%">
        <div
          v-for="(product, i) in productsRight"
          :key="i"
          class="d-flex justify-content-start align-items-center mt-5 product-item"
        >
          <div class="product-img-container">
            <img :src="product.negativeImage" />
            <img :src="product.activeImage" />
          </div>
          <div class="th-ml-36">
            <div class="product-subtitle th-fs-24">{{ product.title }}</div>
            <div class="product-desc th-fs-16 ts-mt-14">{{ product.desc }}</div>
          </div>
        </div>
      </div>
    </div>
  </Content>
</template>
<script>
import Content from '@/shared/components/content.vue'
import { products } from './data.js'
export default {
  name: 'DesktopProduct',
  components: { Content },
  setup() {
    return {
      productsLeft: [products[0], products[1], products[2]],
      productsRight: [products[3], products[4], products[5]],
    }
  },
}
</script>

<style lang="scss" scoped>
.app-preview-img {
  width: 296px;
  height: 520px;
  object-fit: contain;
  flex: 0;
}

.product-subtitle {
  color: #333;
}

.product-desc {
  color: #666;
}

.product-img-container {
  position: relative;
  width: 88px;
}

.product-img-container img {
  width: 100%;
}

.product-img-container img:last-child {
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
}

.product-item:hover {
  .product-subtitle,
  .product-desc {
    color: #4b7ef6 !important;
  }

  .product-img-container img:last-child {
    opacity: 1;
  }
}
</style>
